import React, { FC, PropsWithChildren } from 'react'
import { useIsAuthenticated } from '@azure/msal-react'
import ErrorHandlingInterceptor from '../components/error-handling/ErrorHandlingInterceptor'
import { AUTH_PROVIDER } from '../App'
import { useAuth } from '../contexts/AuthContext'

import { SpinnerIcon } from '@sistemiv/s-components'
import { Outlet } from 'react-router-dom'

const PrivateRoute: FC<PropsWithChildren> = ({ children }) => {
  const isAuth = useIsAuthenticated()
  const { loading, isLoggedIn } = useAuth()

  const isAuthenticated = AUTH_PROVIDER === 'msal' ? isAuth : isLoggedIn

  if (loading && AUTH_PROVIDER === 'ory') {
    return (
      <div className='w-full flex justify-center pt-5'>
        <SpinnerIcon className='text-sky-500 h-7 w-7 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2' />
      </div>
    )
  }

  return isAuthenticated ? <ErrorHandlingInterceptor>{children}</ErrorHandlingInterceptor> : <Outlet />
}

export default PrivateRoute
